import PendingFunds from './PendingFunds.container'
export default PendingFunds
